<template>
  <div class="admin-login-container">
    <h2>Admin Login</h2>
    <form @submit.prevent="login">
      <div>
        <label>Username</label>
        <input v-model="username" type="text" required />
      </div>
      <div>
        <label>Password</label>
        <input v-model="password" type="password" required />
      </div>
      <button type="submit">Login</button>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "AdminLogin",
  setup() {
    const username = ref("");
    const password = ref("");
    const error = ref("");
    const router = useRouter();

    const login = async () => {
      error.value = "";
      const res = await fetch("http://localhost:5001/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: username.value, password: password.value }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("admin_token", data.token);
        router.push("/admin/team");
      } else {
        error.value = "Invalid username or password";
      }
    };

    return { username, password, error, login };
  },
});
</script>

<style scoped>
.admin-login-container {
  max-width: 400px;
  margin: 100px auto;
  padding: 32px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 16px rgba(0,0,0,0.04);
}
.admin-login-container h2 {
  text-align: center;
  margin-bottom: 24px;
}
.admin-login-container form > div {
  margin-bottom: 16px;
}
.admin-login-container label {
  display: block;
  margin-bottom: 4px;
  color: Black;
}
.admin-login-container input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.admin-login-container button {
  width: 100%;
  padding: 10px;
  background: #4c4cff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
}
.error {
  color: #d00;
  margin-top: 10px;
  text-align: center;
}
</style> 